import { useContext } from 'react';
import { SharedContext } from '../context/SharedProvider/SharedProvider';
function useSharedState() {
    const context = useContext(SharedContext);
    if (context === undefined) {
        throw new Error('useSharedState must be used within a SharedProvider');
    }
    return { ...context };
}
export default useSharedState;
